document.addEventListener('DOMContentLoaded', function () {
  var banners = document.querySelectorAll('[data-hero-banner]');

  banners.forEach(function (banner) {
    var track = banner.querySelector('[data-hero-track]');
    var slides = banner.querySelectorAll('[data-hero-slide]');
    var dots = banner.querySelectorAll('[data-hero-dot]');
    var prevBtn = banner.querySelector('[data-hero-prev]');
    var nextBtn = banner.querySelector('[data-hero-next]');
    if (!track || slides.length === 0) return;

    var currentIndex = 0;
    var autoplayTimer = null;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
        restartAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
        restartAutoplay();
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        restartAutoplay();
      });
    });

    // Detecta qué slide está visible para actualizar los dots
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var index = Array.prototype.indexOf.call(slides, entry.target);
          currentIndex = index;
          setActiveDot(index);
        }
      });
    }, { root: track, threshold: 0.6 });

    slides.forEach(function (slide) {
      observer.observe(slide);
    });

    // ===== Autoplay =====
    function startAutoplay() {
      if (!window.__heroAutoplay || slides.length < 2) return;
      autoplayTimer = setInterval(function () {
        goTo(currentIndex + 1);
      }, window.__heroAutoplaySpeed || 5000);
    }
    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    startAutoplay();
    banner.addEventListener('mouseenter', stopAutoplay);
    banner.addEventListener('mouseleave', startAutoplay);
    banner.addEventListener('touchstart', stopAutoplay, { passive: true });
  });
});